import { actions } from '../../utils/constants';

export const logout = () => {
    return {
        type: actions.LOGOUT_DO,
    };
};



// WEBPACK FOOTER //
// ./src/components/header/header.action.js